/* eslint eqeqeq: "off", no-unused-vars: "off" */
import React, { useState, Fragment } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import createuuid from 'uuid';

import BWSchema from './form/validation-schema';

import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';

import SaveButton from '../../components/buttons/save-button';
import CircleProgress from '../../components/progress/circle';
import CREATE_ITEM from './mutations/createItem';
import GET_ITEMS from './queries/listItems';

import BWSoldTo from './form/sold-to';
import BWContacts from './form/contacts';

import './create-form.scss';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 350
  },
  textMultiline: {
    width: '100%',
    minHeight: '3em'
  },
  dense: {
    marginTop: 19
  },
  menu: {
    width: 200
  },
  formControl: {
    minWidth: 200,
    marginRight: 15
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  firstInput: {
    marginLeft: 0,
    paddingLeft: 0
  },
  formSection: {
    margin: '20px 0'
  },
  sectionItem: {
    marginTop: 0
  },
  errorText: {
    color: theme.palette.error.main,
    margin: 0
  }
}));

const initialFormValues = {
  bw_name: '',
  sold_to: [],
  contacts: []
};

const mutationUpdate = (params) => {
  return {
    update(cache, { data }) {
      const listCache = cache.readQuery({ query: GET_ITEMS });
      listCache.getAllBWItems.push(data.createContactItem);

      cache.writeQuery({
        query: GET_ITEMS,
        data: listCache
      });
    }
  };
};
const CreateContact = (props) => {
  const [createItem, { data, error }] = useMutation(
    CREATE_ITEM,
    mutationUpdate()
  );
  const classes = useStyles();
  const { match, history } = props;
  const { params } = match;

  const submitForm = async (data) => {
    data.contacts = data.contacts.map((item) => {
      return {
        phone: item.phone || null,
        email: item.email
      };
    });

    await createItem({
      variables: {
        input: data
      }
    });

    history.push('/contacts');
  };

  return (
    <Fragment>
      <Typography variant="h1">Create Branded Wholesaler</Typography>
      <div className="create-form">
        <Formik
          validationSchema={BWSchema}
          initialValues={initialFormValues}
          onSubmit={submitForm}
        >
          {({
            values,
            errors,
            status,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="bw-form-row">
                  <FormControl className={classes.formControl}>
                    <TextField
                      className={classes.textField}
                      label="Branded Wholesaler Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.bw_name}
                      name="bw_name"
                      type="text"
                    />
                  </FormControl>
                  <FormHelperText className={classes.errorText}>
                    {errors.bw_name}
                  </FormHelperText>
                </div>
                <div className={`bw-form-row ${classes.formSection}`}>
                  <BWSoldTo
                    data={values.sold_to}
                    classes={classes}
                    onChange={handleChange}
                    errors={errors.sold_to}
                  />
                </div>

                <div className={`bw-form-row ${classes.formSection}`}>
                  <BWContacts
                    data={values.contacts}
                    classes={classes}
                    onChange={handleChange}
                    errors={errors.contacts}
                  />
                </div>
                <SaveButton label="Save" onClick={() => handleSubmit(values)} />
              </form>
            );
          }}
        </Formik>
      </div>
    </Fragment>
  );
};

export default CreateContact;
